// MoneyWorks supplier names. Missing MW_ADDRESS comes back as 422 and is toasted.
export const GET_MW_NAMES = "GET_MW_NAMES";
export const getMWNames = (opts = {}) => {
  const params = opts.refresh ? { refresh: "true" } : {};
  const request = axios.get("/moneyworks/names.json", { params }).catch((err) => {
    const msg = err?.response?.data?.error || "Could not load MoneyWorks companies";
    toastr.error(typeof msg === "string" ? msg : JSON.stringify(msg));
    return Promise.reject(err);
  });
  return {
    type: GET_MW_NAMES,
    payload: request,
  };
};
